export default class SoterService {

    listJ() {
        return {
            l: "E)H@McQfTjWnZr4u",
            v: "D(G+KbPeShVmYq3t",
        }
    }
}
